import e from "../../utils/classNames.js";
import { AppMenuDropdown as t } from "./AppMenuDropdown.js";
import n from "./AppMenuContent.js";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/applicationHeader/AppMenu.tsx
var i = (i) => {
	let { label: a = "Unknown", appMenuItems: o = [], appNavigatorClassName: s, appNavigator: c, onToggleAppMenu: l, ...u } = i, d = !!(o?.length || c), f = e("ModuleNavigation AppMenu", "user-select-none", d && "hasModules", !c && "pointer-events-none", s && s);
	return /* @__PURE__ */ r("ul", {
		...u,
		className: f,
		children: /* @__PURE__ */ r(t, {
			title: a,
			caret: d,
			onToggleAppMenu: l,
			children: c && /* @__PURE__ */ r(n, {
				appMenuItems: o,
				appNavigator: c
			})
		})
	});
};
//#endregion
export { i as default };

//# sourceMappingURL=AppMenu.js.map